import React, { useEffect, useState, useContext, useRef, SyntheticEvent } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";

import "./normal-table.scss";
import { memo } from "react";
import { Fragment } from "react";
import { Table as BootstrapTable } from "react-bootstrap";
import { BsTrash } from "react-icons/bs";
import { BsArrowRight } from "react-icons/bs";
import { FaCheck } from "react-icons/fa";
import { LiaPlusSolid } from "react-icons/lia";
import { PiDotsSixVerticalLight } from "react-icons/pi";
import {  RiArrowDownSLine, RiArrowUpSLine } from "react-icons/ri";
import { useParams } from "react-router";
import { IParentData } from "../../../analytics/pages/report-details/report-details";
import TextInput from "../../../shared/components/text-input/text-input";
import Tooltip from "../../../shared/components/tooltip/tooltip";
import AuthContext from "../../../shared/context/auth-context";
import { IDataType } from "../../../shared/definitions/datatypes";
import { roleAdmin, roleRead, roleWrite } from "../../constants/user-roles";
import { IListPageData } from "../../utils/api";
import { getTheLastParam, moveArrayElement, transformName } from "../../utils/utils";
import CheckboxInput from "../checkbox-input/checkbox-input";
import CustomCheckbox from "../custom-checkbox/custom-checkbox";


export interface IResultFiltered {
  [index: string]: string | boolean;
}

export interface IAnyString {
  [index: string]: string;
}

export interface ISettings {
  csv_separator: string, 
  datetime_format: string
}

export interface ITableRowData {
  id: string;
  [index: string]: any; // eslint-disable-line
}

export interface ITableRowDataToBeSent {
  dataToBeSaved: ITableRowData[];
  dataToBeDeleted: ITableRowData[];
}

export interface IColumn {
  key: string;
  displayName: string;
  id?: string;
  model?: string;
  dataType: IDataType;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  subType?: string;
  noEmptyDefault?: boolean;
  inputTypeLimit?: number;
  onlyWholeNumbers?: boolean;
  autocompleteOff?: boolean;
  controlled?: boolean;
  nonSortable?: boolean;
  extraClass?: string;
  onFocusEmpty?: boolean;
  generateUniqueId?: boolean;
  noLabel?: boolean; 
  errorMsg?: string;
  extraToolTipInfo?: string;
  noWrap?: boolean;
  smart?: boolean;
  valueType?: string;
  decimalsFormatting?: number;
}

export interface IScale {
  width: number | string,
  height: number | string,
}

export interface ITableConfig {
  columns: IColumn[];
  unblockInput?: boolean;
  dataUrl?: string;
  fetchedData?: IListPageData | undefined;
  hideButtons: string[];
  allStatus?: string | null;
  hideSearchInput?: boolean;
  allStatusDelete?: string | null;
  hideCheckBoxes?: boolean;
  timeframeStartTilEnd?: boolean;
  clickRowToSelectMode?: boolean;
  editColumsOrder?: boolean;
  scale?: IScale;
  subHeader?: string;
  extraClass?: string;
  timeFrameIsAstring?: boolean;
  verticallyHighlighted?: string[];
  initialySelectedRows?: string[];
  defaultSortCol?: string;
  selectedRowId?: string;
  defaultSortColStyle?: string;
  orderSettings?: IParentData;
  draggingStarted?: boolean;
  tobeDeselected?: string[];
  alwaysDisplayColHeaders?: boolean;
  allowCollapsedText?: boolean;
  textTruncateLimit?: number;
  getDraggingStatus?: (toggle: boolean) => void;
  getNewColumnsOrder?: (data: IParentData, order: IColumn[]) => void;
  getSelectedRowsData?: (data: ITableRowData[]) => void;
  handleOnDelete?: (ids: string[]) => void;
  onRowClickAction?: (id: string, rowData: ITableRowData) => void;
  onAddButtonClickAction?: () => void;
  renderExtraTableBtns?: () => JSX.Element;
  extraHeaders?: string[];
  renderExtraColumns?: (id: string, columnData?: string) => JSX.Element;
  onTableScrollAction?: (offset: number) => void;
  sortBy?: (searchQuesry: string, key?: string) => void;
  isRowClickable?: boolean;
}

interface ITableState {
  rowData: ITableRowData[];
}

interface ISortedBy {
  column: undefined | string;
  direction: undefined | string;
}
interface ICollapsedState {
  [key: string]: boolean;
}

const NormalTable = ({ columns, defaultSortColStyle, selectedRowId, alwaysDisplayColHeaders, subHeader, getNewColumnsOrder, extraClass, onTableScrollAction, tobeDeselected, verticallyHighlighted, timeFrameIsAstring, renderExtraTableBtns, onAddButtonClickAction, draggingStarted, getDraggingStatus, orderSettings, editColumsOrder, timeframeStartTilEnd, scale, allStatus, defaultSortCol, initialySelectedRows, sortBy, renderExtraColumns, onRowClickAction, hideButtons, clickRowToSelectMode, hideCheckBoxes, hideSearchInput, unblockInput, allStatusDelete, handleOnDelete, getSelectedRowsData, dataUrl, fetchedData, extraHeaders, isRowClickable, allowCollapsedText, textTruncateLimit = 100 }: ITableConfig) => {
  const [checkAll, setCheckAll] = useState(false);
  const [searchInputValue, setSearchInputValue] = useState("");
  const [data, setData] = useState<ITableState>({ rowData: []});

  const [selectedRows, setSelectedRows] = useState<string[]>([]);
  const [selectedRowsByParent, setSelectedRowsByParent] = useState<string[]>([]);

  const [scrolled, setScrolled] = useState(false);
  const [sortedByCol, setSortedByCol] = useState<ISortedBy>({column: undefined, direction: undefined});
  const [readOnlyState, setReadOnlyState] = useState(false);
  const [columnsData, setColumnsData] = useState<IColumn[]>();
  const [draggedOverKey, setDraggedOverKey] = useState("");
  const [draggedKey, setDraggedKey] = useState("");
  const [paginationOffset, setPaginationOffset] = useState(0);
  const [collapsedState, setCollapsedState] = useState<ICollapsedState>({});

  const navigate = useNavigate();
  
  const params = useParams();
  const authCtx = useContext(AuthContext);
  const node = useRef<any>(); // eslint-disable-line 

  useEffect(() => {
    if (tobeDeselected) {
      const selectedRowsFiltered = selectedRows.filter((selectedRowId:string) => tobeDeselected.indexOf(selectedRowId) === -1);
      setSelectedRowsByParent(selectedRowsFiltered);
    }
  }, [tobeDeselected]);

  useEffect(() => {
    setColumnsData(columns);
  }, [columns]);

  useEffect(() => {
    const rolesArray = authCtx.selectedTenant.roles;
    if (rolesArray.length <= 1 && rolesArray.indexOf(roleRead) !== -1 && !authCtx.systemAdmin){
      setReadOnlyState(true);
    } else {
      setReadOnlyState(false);
    }
  }, [authCtx.selectedTenant.roles]);

  useEffect(() => {
    if (fetchedData && allStatus === "completed" && Array.isArray(fetchedData.rows)) {
      if (initialySelectedRows) {
        setSelectedRows(initialySelectedRows?.length !== 0? initialySelectedRows : []);
      }
    }
  }, [initialySelectedRows]);

  useEffect(() => {
    if (fetchedData && allStatus === "completed" && Array.isArray(fetchedData.rows)) {
      setData({ ...data, rowData: fetchedData.rows});
    }
  }, [fetchedData]);

  useEffect(() => {
    if (defaultSortCol) {
      setSortedByCol({column: defaultSortCol, direction: defaultSortColStyle? defaultSortColStyle : "asc"});
    }
  }, [defaultSortCol]);

  useEffect(() => {
    if (allStatusDelete === "completed") {
      setSelectedRows([]);
      setData({ ...data });
    }
  }, [allStatusDelete]);

  const toggleCollapsed = (rowId: string, columnKey: string) => {
    const key = `${rowId}-${columnKey}`;
    setCollapsedState(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };

  const isCollapsed = (rowId: string, columnKey: string): boolean => {
    const key = `${rowId}-${columnKey}`;
    return collapsedState[key] !== false;
  };

  const shouldTruncate = (text: string): boolean => {
    return !!allowCollapsedText && typeof text === 'string' && text.length > textTruncateLimit;
  };

  const getTruncatedText = (text: string, rowId: string, columnKey: string): JSX.Element | string => {
    if (!shouldTruncate(text)) {
      return text;
    }

    const collapsed = isCollapsed(rowId, columnKey);
    const displayText = collapsed ? text.substring(0, textTruncateLimit) + '...' : text;

    return (
      <span>
        {displayText}
        <button
          id="nonClick"
          className={`normalTable-toggleText ${collapsed ? 'normalTable-toggleText-collapsed' : 'normalTable-toggleText-expanded'}`}
          onClick={(e) => {
            e.stopPropagation();
            toggleCollapsed(rowId, columnKey);
          }}
        >
          {collapsed ? 'Show more' : 'Show less'}
        </button>
      </span>
    );
  };

  const handleOnSelectRow = (id: string) => {
    const rowDataCopy = [...data.rowData];
    const result = [...selectedRows];
    
    if (result.indexOf(id) === -1) {
      // not found=>add
      result.push(id);
      
      if (dataUrl === "tenants/new" || dataUrl === "user-groups/new") {
        const addedDefaultRole = rowDataCopy.map((row) => {
          if (row.id === id && (!row.roles || row.roles.length === 0)) {
            return {...row, roles: [roleRead]};
          }
          return row;
        });
        
        setSelectedRows(result);
        setData({ ...data, rowData: addedDefaultRole });
        getSelectedRowsData && getSelectedRowsData(addedDefaultRole.filter(row => result.indexOf(row.id) !== -1));
        return undefined;
      }

      const filteredInOrder:ITableRowData[] = [];
      result.map(rowId => {
        const findData = rowDataCopy.find((row) => rowId === row.id);
        findData && filteredInOrder.push(findData);
      });
      getSelectedRowsData && getSelectedRowsData(filteredInOrder);
      setSelectedRows(result);
      setData({ ...data });   
    } else {
      if (dataUrl === "tenants/new" || dataUrl === "user-groups/new") {
        const removedRoles = rowDataCopy.map((row) => {
          if (row.id === id && (row.roles || row.roles.length !== 0)) {
            return {...row, roles: []};
          }
          return row;
        });

        const filtered = result.filter((el) => el !== id);
        setData({ ...data, rowData: removedRoles });
        setSelectedRows(filtered);
        getSelectedRowsData && getSelectedRowsData(rowDataCopy.filter(row => filtered.indexOf(row.id) !== -1));
        return undefined;
      }

      const filteredListOfIds = result.filter((el) => el !== id);
      getSelectedRowsData && getSelectedRowsData(rowDataCopy.filter(row => filteredListOfIds.indexOf(row.id) !== -1));
      setData({ ...data });
      setSelectedRows(filteredListOfIds);
    }
  };

  const handleOnSelectAllRows = () => {
    const rowDataCopy = [...data.rowData];
    if (data.rowData && !checkAll) {
      const result = rowDataCopy.map((row) => row.id);
      if (dataUrl === "tenants/new" || dataUrl === "user-groups/new") {
        const addedDefaultRole = rowDataCopy.map((row) => {
          if (!row.roles || row.roles.length === 0) {
            return {...row, roles: [roleRead]};
          }  
          return {...row, roles: [...row.roles,roleRead]};         
        });
        setData({ ...data, rowData: addedDefaultRole });
        setSelectedRows(result);
        setCheckAll(true);
        return undefined;
      }
      getSelectedRowsData && getSelectedRowsData(data.rowData.filter(row => result.indexOf(row.id) !== -1));

      setData({ ...data});
      setSelectedRows(result);
      setCheckAll(true);
    } else {
      getSelectedRowsData && getSelectedRowsData([]);

      if (dataUrl === "tenants/new" || dataUrl === "user-groups/new") {
        const removedRoles = rowDataCopy.map((row) => {
          return {...row, roles: []};
        });
        setData({ ...data, rowData: removedRoles });
        setSelectedRows([]);
        setCheckAll(false);
        return undefined;
      }
      setSelectedRows([]);
      setData({ ...data });
      setCheckAll(false);
    }
  };

  const isSelected = (id:string, checkedByStatus: string) => {
    if (checkedByStatus) {
      return true;
    }
    else if (selectedRows.indexOf(id) !== -1) {
      return true;
    }
    if (selectedRowsByParent.indexOf(id) === -1) {
      return false;
    }
    return false;
  };

  const handleOnSelectRole = (id: string, role: string, status: boolean) => {
    const copy = [...data.rowData];
    const result = copy.map((row) => {
      if (row.id === id && status) {
        const roles = row.roles ? row.roles : [];
        return {...row, roles: [...roles, role]};
      } else if (row.id === id && !status) {
        const roles = row.roles ? row.roles : [];
        roles.splice(roles.indexOf(role), 1);
      }      
      return row;
    });

    const selectedRowsCopy = [...selectedRows];

    if (selectedRowsCopy.indexOf(id) === -1) {
      // if row is not selected and Role is selected => select the row
      selectedRowsCopy.push(id);
      getSelectedRowsData && getSelectedRowsData(result.filter(row => selectedRowsCopy.indexOf(row.id) !== -1));
      setSelectedRows(selectedRowsCopy);
      setData({ ...data, rowData: result });
    } else {
      const findRow = result.find((el) => el.id === id);

      if (findRow && findRow.roles) {
        // row is selected, roles exist
        getSelectedRowsData && getSelectedRowsData(result.filter(row => selectedRowsCopy.indexOf(row.id) !== -1));
        setData({ ...data, rowData: result });
      }  
      if (findRow && findRow.roles.length === 0) {
        // after deselecting the last role => deselect the row
        const filtered = selectedRowsCopy.filter((el) => el !== id);
        getSelectedRowsData && getSelectedRowsData(result.filter(row => filtered.indexOf(row.id) !== -1));
        setSelectedRows(filtered);
        setData({ ...data, rowData: result });
      }
    }
  };

  const renderRows = () => {
    if (!data || !data.rowData || !columnsData) {
      return;
    }
    const result = data.rowData.filter(row => {
      const columnsKeys = columnsData.map(column => column.key);
      let resultFilteredForMatching:IResultFiltered = {};
      let concatResultFilteredForMatching = "";

      columnsKeys.forEach(key => {
        if (key === "timeframe" && timeframeStartTilEnd) {
          resultFilteredForMatching = {...resultFilteredForMatching, timeframe_from : row.timeframe_from, timeframe_to : row.timeframe_to,};
        } else {
          resultFilteredForMatching = {...resultFilteredForMatching, [key] : row[key]};
        }
      });
      for (const key in resultFilteredForMatching) {
        concatResultFilteredForMatching = concatResultFilteredForMatching.toString().toLowerCase() + " " + (resultFilteredForMatching[key]? resultFilteredForMatching[key].toString().toLowerCase() : "");
      }

      return concatResultFilteredForMatching.indexOf(searchInputValue.toLowerCase()) > -1;
    });
    
    return result.map((rowData: ITableRowData, i: number) => {
      let checkedByStatus= "";
      if (rowData.approved) {
        checkedByStatus = "-approved";
      } else if (rowData.recommended || (selectedRowId && selectedRowId === rowData.id) ) {
        checkedByStatus = "-recommended";
      } else if (rowData.edited) {
        checkedByStatus = "-edited";
      } else if (rowData.deleted) {
        checkedByStatus = "-deleted";
      }
      return (
        <tr
          className={`normalTable-row${checkedByStatus} ${rowData?.status ? rowData?.status : ""} ${rowData.archived ? "archived" : ""}`}
          key={i}
          onClick={(e) => {
            if (isRowClickable === false) {
              return;
            }
            
            if (
              (e.target as Element).id.split("_")[0] !== "checkbox" &&
              (e.target as Element).id !== "nonClick" &&
              (e.target as Element).className !== "form-check-input" &&
              (e.target as Element).className !== "normalTable-toggleText"
            ) {
              onRowClickAction && onRowClickAction(rowData.id, rowData);
              clickRowToSelectMode && handleOnSelectRow(rowData.id);
              if (dataUrl === "noPropagation" || dataUrl === "tenants/new" || dataUrl === "user-groups/new" || dataUrl === "reports/:id" || dataUrl === "/analytics/run-status" || onRowClickAction) {
                e.stopPropagation();
              } else if (dataUrl !== "datasets/:id") {
                navigate(`${rowData.id}`);
              } else {
                navigate(`/analytics/modelconfig/${rowData.id}`);
              }
            }
            e.stopPropagation();
          }}
        >
          {hideCheckBoxes ? "" : <td key={rowData.id}>
            <span>
              <CheckboxInput rowData={rowData} id={`checkbox_${i}`} readOnlyState={readOnlyState? readOnlyState : !unblockInput} checked={isSelected(rowData.id, checkedByStatus)} onChange={() => handleOnSelectRow(rowData.id)} />
            </span>
          </td>}
          {columnsData.map((column) => {
            let columnData = rowData[column.key];
            const isVerticallyHighlighted = verticallyHighlighted && verticallyHighlighted.indexOf(column.key) !== -1;
            let extraRowCellClass = "standardNoHighlight";
            if (isVerticallyHighlighted) {
              if (checkedByStatus === "-approved") {
                extraRowCellClass = "verticallyHighlitedAprroved";
              } else if (checkedByStatus === "-recommended") {
                extraRowCellClass = "verticallyHighlitedRecommended";
              } else {
                extraRowCellClass = "verticallyHighlitedStandard";
              }
            }
            const checkIfBool = (column.key === "active" || column.key === "manager" || column.key === "analytics" || column.key === "unlimited" || column.key == "archived" 
                                  || column.key == "is_global" || column.key == "is_installation" || column.key == "sygno_default");
            if (columnData === true && checkIfBool) {
              columnData = (
                <Fragment>
                  {<FaCheck className="normalTable-activeIcon" />}
                </Fragment>
              );
            } 
            else if (columnData === false && checkIfBool) {
              columnData = (
                <Fragment></Fragment>
              );
            }  else if ((columnData === true || columnData === false) && column.key !== "active") {
              columnData = columnData.toString();
            }
            if (column.key==="roles" && dataUrl === "tenants/new") {
              columnData = (
                <Fragment>
                  <CustomCheckbox name={rowData.name} disabled={readOnlyState || !unblockInput || !authCtx.systemAdmin} readOnlyState={readOnlyState} initialValue={columnData && columnData.indexOf(roleAdmin) !== -1} handleOnSelectRole={handleOnSelectRole} id={rowData.id} text={roleAdmin} />
                  <CustomCheckbox name={rowData.name} disabled={readOnlyState || !unblockInput} readOnlyState={readOnlyState? readOnlyState : !unblockInput} initialValue={columnData && columnData.indexOf(roleWrite) !== -1} handleOnSelectRole={handleOnSelectRole} id={rowData.id} text={roleWrite} />
                  <CustomCheckbox name={rowData.name} disabled={readOnlyState || !unblockInput} readOnlyState={readOnlyState? readOnlyState : !unblockInput} initialValue={columnData && columnData.indexOf(roleRead) !== -1} handleOnSelectRole={handleOnSelectRole} id={rowData.id} text={roleRead} />
                </Fragment>
              );
            }
            if (column.key==="timeframe" && timeframeStartTilEnd) {
              columnData = `${rowData["timeframe_from"]} - ${rowData["timeframe_to"]}`;
            }
            if (column.key==="timeframe" && !timeframeStartTilEnd) {
              columnData = rowData.timeframe? new Date(rowData.timeframe).toLocaleDateString() : "";
            }
            if (column.key==="timeframe" && timeFrameIsAstring) {
              columnData = rowData.timeframe;
            }
            if (column.key==="date") {
              columnData = rowData.date? new Date(rowData.date).toLocaleString() : "";
            }
            if (column.key==="start_timestamp") {
              columnData = rowData.start_timestamp? new Date(rowData.start_timestamp).toLocaleString() : "";
            }
            if (column.key==="end_timestamp") {
              columnData = rowData.end_timestamp? new Date(rowData.end_timestamp).toLocaleString() : "";
            }
            if (column.key === "state") {
              if (rowData.state === "test") {
                columnData = "Testing";
              } else if (rowData.state === "pending_production_approval") {
                columnData = "Pending Production Approval";
              } else if (rowData.state === "production") {
                columnData = "Production";
              } else if (rowData.state === "in_progress") {
                columnData = "Model Generation In Progress";
              } else {
                columnData = "";
              }
            }
            if (column.key === "state_update") {
              columnData = <Fragment><div className="normalTable-oldState">{transformName(rowData.old_state)}</div><BsArrowRight className="normalTable-rowCellIcon" /> {transformName(rowData.current_state)}</Fragment>;
            }
            
            if (typeof columnData === 'string' && allowCollapsedText) {
              columnData = getTruncatedText(columnData, rowData.id, column.key);
            }

            return <td className={extraRowCellClass} key={column.key}><span className={column.noWrap? "noWrap" : ""}>{columnData}</span></td>;
          })}
          {renderExtraColumns && renderExtraColumns(rowData.id, rowData.modelversion_name)}
        </tr>
      );
    });
  };

  const sortColumVals = (key: string) => {
    let defineDirection;
    if (sortedByCol.direction === undefined) {
      defineDirection = "asc";
    } else if (sortedByCol.column !== key) {
      defineDirection = "asc";
    } else if (sortedByCol.column === key && sortedByCol.direction === "asc") {
      defineDirection = "desc";
    } else {
      defineDirection = "asc";
    }
    setSortedByCol({column: key, direction: defineDirection});
    sortBy && sortBy(`?order_by=${key} ${defineDirection}`, key);
  };

  const defineSortingArrows = (key: string) => {
    if (sortedByCol.direction === undefined) {
      return <RiArrowDownSLine />;
    } else if (sortedByCol.column !== key) {
      return <RiArrowDownSLine />;
    } else if (sortedByCol.column === key && sortedByCol.direction === "desc") {
      return <RiArrowUpSLine />;
    } else {
      return <RiArrowDownSLine />;
    }
  };

  const onDragEndHandler = () => {
    let indexOfDragged;
    let indexOfDraggedOver;

    columnsData?.forEach((col, i) => {
      if (col.key === draggedKey) {
        indexOfDragged = i;
      } else if (col.key === draggedOverKey) {
        indexOfDraggedOver = i;
      }
    });
    if (indexOfDragged !== indexOfDraggedOver && (indexOfDraggedOver !== undefined && indexOfDragged !== undefined)) {
      // add over instead of swaping
      const result = moveArrayElement(columnsData, indexOfDraggedOver, indexOfDragged);
      setColumnsData(result);
      (orderSettings && getNewColumnsOrder) && getNewColumnsOrder(orderSettings, result);
    }
    getDraggingStatus && getDraggingStatus(false);
  };

  useEffect(() => {
    if (!draggingStarted) {
      setDraggedOverKey("");
      setDraggedKey("");
    }
  }, [draggingStarted]);

  return (
    <div className={`normalTable ${extraClass}`}>
      <div className="normalTable-buttonsGroup">
        {subHeader && <span className="normalTable-buttonsGroup-header"><span>{subHeader}</span></span>}
        {hideSearchInput? "" : <TextInput
          type={"text"}
          id={"normalTable-searchUserInput"}
          required={false}
          inputKey={"normalTable-searchUserInput"}
          autofocus={false}
          placeholder={"Type to filter"}
          handleOnChange={(targetVal) => setSearchInputValue(targetVal)}
        />}
        {dataUrl === "datasets/:id" ?
          <Fragment>
            {hideButtons.indexOf("delete") === -1? <Tooltip content={"Delete"} direction="top" delay={350} >
              <Button name="delete" disabled={selectedRows.length === 0 || (readOnlyState || !unblockInput) && !authCtx.systemAdmin} onClick={() => handleOnDelete && handleOnDelete(selectedRows)} className="tableNormal-delete" variant="primary">
                <BsTrash />
              </Button>
            </Tooltip> : ""}

            {hideButtons.indexOf("add") === -1? <Tooltip content={"New Model Configuration"} direction="top" delay={350} >
              <Button
                name="add"
                onClick={() => navigate(`/analytics/datasets-details/${params.id}/modelconfig/new`)}
                className="normalTable-new"
                variant="primary"
                disabled={(readOnlyState || !unblockInput)}
              >
                <LiaPlusSolid />
              </Button>
            </Tooltip> : ""}
          </Fragment>
          : ""}
        {dataUrl === "datasets/:id" || dataUrl === "noPropagation" || dataUrl==="screen/:id" || dataUrl === "tenants/new" || dataUrl === "reports/:id" || dataUrl === "user-groups/new" ? "" : (
          <Fragment>
            {hideButtons.indexOf("delete") === -1? <Tooltip content={"Delete"} direction="top" delay={350} >
              <Button 
                name="delete"
                disabled={selectedRows.length === 0 || (allStatusDelete === "pending" || readOnlyState || !unblockInput)}
                onClick={() => {
                  setSelectedRows([]);
                  handleOnDelete && handleOnDelete(selectedRows);
                }}
                className="normalTable-delete"
                variant="primary"
              >
                <BsTrash />
              </Button>
            </Tooltip> : ""}

            {renderExtraTableBtns && renderExtraTableBtns()}
          
            {hideButtons.indexOf("add") === -1? <Tooltip content={"Add New"} direction="top" delay={350} >
              <Button
                name="add"
                onClick={() => onAddButtonClickAction? onAddButtonClickAction() : navigate("new")}
                className="normalTable-new"
                variant="primary"
                disabled={readOnlyState || !unblockInput}
              >
                <LiaPlusSolid />
              </Button>
            </Tooltip> : ""}
            
          </Fragment>
        )}

      </div>
      {data?.rowData.length !== 0 || alwaysDisplayColHeaders ?<div ref={node} onScroll={(event: SyntheticEvent<HTMLDivElement>) => {
        if (onTableScrollAction) {
          const bottom = event.currentTarget.scrollHeight - event.currentTarget.scrollTop === event.currentTarget.clientHeight;
          if (bottom) {
            onTableScrollAction(paginationOffset + 1);
            setPaginationOffset(prev => prev + 1);
          }
        }
        if (event.currentTarget.scrollTop === 0) {
          setScrolled(false);
        } else {
          !scrolled && setScrolled(true);
        }
      }} style={scale? {"height" : `${scale.height}px`} : undefined } className={`${dataUrl === "tenants/new" || dataUrl === "user-groups/new" ? "normalTable-short-container" : "normalTable-container"} ${scrolled? "scrolled" : ""}`}><BootstrapTable size="sm" borderless striped>
          <thead>
            <tr>
              {hideCheckBoxes? "" : <th className="normalTable-actionTh" key={"actions"}><span><CheckboxInput checked={selectedRows.length === data.rowData.length} readOnlyState={readOnlyState? readOnlyState : !unblockInput} onChange={() => handleOnSelectAllRows()} /></span></th>}
              {columnsData && columnsData.map((column) => (
                <th 
                  onClick={() => !column.nonSortable && sortColumVals(column.key)}
                  draggable={editColumsOrder && true}
                  onDragStart={() => {editColumsOrder && setDraggedKey(column.key); getDraggingStatus && getDraggingStatus(true);}}
                  onDragOver={() => editColumsOrder && setDraggedOverKey(column.key)}
                  onDragEnd={() => editColumsOrder && onDragEndHandler()}
                  // add no wrap class for frac?
                  className={`normalTable${!column.nonSortable ? "-sortable" : "-nonSortable"} ${
                    column.key?.includes("frac") ? "frac" : ""
                  } ${draggedOverKey === column.key && draggingStarted ? "draggedOver" : ""} ${
                    column.key === sortedByCol.column ? "selectedCol" : ""
                  }`}
                  key={column.key}>
                  <span className="normalTable-draggableIcon">
                    <PiDotsSixVerticalLight/>
                  </span>
                  <span>
                    {column.displayName} {(!column.nonSortable && sortBy) && defineSortingArrows(column.key)}
                  </span>
                </th>
              ))}
              {getTheLastParam() === "datasets" ? <th key={"reports"}></th> : ""}
              {dataUrl === "datasets/:id" ? <th key={"edit-risks"}></th> : ""}
              {dataUrl === "datasets/:id" ? <th key={"generate-model"}></th> : ""}
              {dataUrl === "/analytics/run-status" ? <th key={"run-status"}></th> : ""}
              {extraHeaders?.map((header, index) => (
                <th key={`extra-header-${index}`} className="extra-header">{header}</th>
              ))}
            </tr>
          </thead>
          <tbody>{renderRows()}</tbody>
        </BootstrapTable></div> : <div className="normalTable-noDataMsg">No data to be displayed...</div>}
    </div>
  );
};

export default memo(NormalTable);
